import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  TotalDriversResponseDTO
} from '../../interfaces/apiInterfaces';

export class GetTotalDriversCommand extends IRequestCommand<
  IGetTotalDriversResponse,
  ErrorDetails,
  IGetTotalDriversCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/drivers/totalDrivers?driverId={driverId}';
  public override setParameters(parameters: IGetTotalDriversCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId
    );
    this._commandUrl = this._commandUrl.replace(
      '{driverId}',
      parameters.driverId ? parameters.driverId : ''
    );
  }
}

export interface IGetTotalDriversCommandParameters extends ICommandParameters {
  carrierUserId: string,
  driverId: string;
}

export interface IGetTotalDriversResponse
  extends TotalDriversResponseDTO,
  ICommandResponse { }
